import css from "./OrderBadge.module.scss"
import { PuxIcon } from "@phonero/pux-react"

export const OrderBadge = ({
  icon,
  text,
  color,
  size,
  border,
}: {
  icon: string
  text: string
  color?: "green" | "light"
  size?: "normal" | "small"
  border?: boolean
}) => {
  color = color ?? "green"
  return (
    <span
      className={css.freeEstablishmentBullet}
      style={{
        transform: size === "small" ? "scale(0.9)" : "",
        backgroundColor: color === "green" ? "var(--pux-color-success)" : "var(--pux-color-light)",
        border: border ? "1px solid var(--pux-color-light-gray)" : "none",
      }}
    >
      <PuxIcon
        icon={icon}
        size={"small"}
        style={{
          color: color !== "green" ? "var(--pux-color-success)" : "",
          paddingTop: "0px",
          marginTop: "0px",
          transform: "translateY(3px)",
        }}
      ></PuxIcon>
      <span
        className={css.text}
        style={{
          color: color === "green" ? "white" : "black",
        }}
      >
        {text}
      </span>
    </span>
  )
}
